<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='600px'>
    <el-form :model='form' label-width='130px' label-position='right' :rules='rules'
             ref='ruleForm' class='mt20' v-loading='importLoading'>
      <el-form-item label='交单日期：' prop='surrenderDate'>
        <el-date-picker
          v-model='form.surrenderDate'
          style='width: 100%;'
          size='mini'
          type='date'
          value-format='yyyy-MM-dd'
          placeholder='请选择交单日期'>
        </el-date-picker>
      </el-form-item>
      <el-form-item label='快递公司：' prop='expressCompany'>
        <el-input v-model='form.expressCompany' size='mini' placeholder='请输入快递公司' />
      </el-form-item>
      <el-form-item label='邮寄单号：' prop='expressNumber'>
        <el-input v-model='form.expressNumber' size='mini' placeholder='请输入邮寄单号' />
      </el-form-item>
      <el-form-item label='交单备注：' prop='surrenderRemarks'>
        <el-input v-model='form.surrenderRemarks' size='mini' placeholder='请输入交单备注' />
      </el-form-item>
      <el-form-item label='委托车导入：' prop='importId'>
        <div class='exportButton' style='display: flex;justify-content: flex-start;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='uploadUrl' :type='2' @importSuccess='importSuccess'
                        @triggerLoading='importLoading = !importLoading' />
          <div v-if='result'>{{ result }}</div>
        </div>
      </el-form-item>
      <el-form-item label='委托商：' prop='consignorId'>
        <el-select v-model='form.consignorId' size='mini' :disabled='true' style='width:100%'
                   placeholder='请选择委托商' value-key='id'>
          <el-option v-for='item in customerOptions' :key='item.id'
                     :label='item.customer_name' :value='item.id' />
        </el-select>
      </el-form-item>
      <el-form-item label='品牌：' prop='brandId'>
        <el-select v-model='form.brandId' size='mini' :disabled='true' style='width:100%'
                   placeholder='请选择品牌' value-key='id'>
          <el-option v-for='item in brandOptions' :key='item.id'
                     :label='item.brand' :value='item.id' />
        </el-select>
      </el-form-item>

      <div class='flex-center-center mt20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { customerInfoSelectList } from '@/service/financial';
  import { getModelList } from '@/service/vehiclelog';
  import BatchImport from '@/components/batchImport';
  import { receiptAddOrUpdate } from '@/service/receipt';

  export default {
    name: 'settlementDeliveryForm',
    components: {
      BatchImport,
    },
    data() {
      return {
        importLoading: false,
        dialogVisible: false,
        dialogTitle: '新增',
        defaultForm: {},
        form: {},
        rules: {
          consignorId: [
            {
              required: true,
              message: '请选择委托商',
              trigger: 'blur',
            },
          ],
          brandId: [
            {
              required: true,
              message: '请选择品牌',
              trigger: 'blur',
            },
          ],
          surrenderDate: [
            {
              required: true,
              message: '请选择交单日期',
              trigger: 'blur',
            },
          ],
          expressCompany: [
            {
              required: true,
              message: '请输入快递公司',
              trigger: 'blur',
            },
          ],
          expressNumber: [
            {
              required: true,
              message: '请输入邮寄单号',
              trigger: 'blur',
            },
          ],
          surrenderRemarks: [
            {
              required: true,
              message: '请输入交单备注',
              trigger: 'blur',
            },
          ],
          importId: [
            {
              required: true,
              message: '请导入委托车',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        customerOptions: [],
        brandOptions: [],
        uploadUrl: '/receiptManage/batchImportVehicle',
        result: '',
      };
    },
    mounted() {
      this.getSelectedData();
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      //模板下载
      download() {
        window.location.href = '/file/结算部交单模板.xlsx';
      },
      importSuccess(res) {
        this.result = `成功导入${res.total}辆委托车`;
        this.form.importId = res.importId;
        this.form.consignorId = res.consignorId;
        this.form.brandId = res.brandId;
      },
      getSelectedData() {
        this.getCustomerInfoSelectList();
        this.getBrand();
      },
      // 获取委托商
      async getCustomerInfoSelectList() {
        const {
          status,
          message,
          data,
        } = await customerInfoSelectList();
        if (status !== 0) return this.$message.warning(message);
        this.customerOptions = data;
      },
      // 获取品牌
      async getBrand() {
        const {
          status,
          message,
          data,
        } = await getModelList();
        if (status !== 0) return this.$message.warning(message);
        this.brandOptions = data;
      },
      dialogOpen(title, row) {
        this.dialogTitle = title;
        this.rules.importId[0].required = title === '新增';
        this.result = '';
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        if (row) this.form = row;
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.submitLoading = true;
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const {
              status,
              message,
            } = await receiptAddOrUpdate({
              ...this.form,
              type: 2,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.submitLoading = false;
            this.dialogClose();
            this.$emit('searchBtn');
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped></style>
